import ConditionPropertiesProvider from './ConditionPropertiesProvider';

const data = {
  __init__: [ 'conditionPropertiesProvider' ],
  conditionPropertiesProvider: [ 'type', ConditionPropertiesProvider ]
};

export default data;